import { useFormik } from "formik";
import React from "react";
import { useCallback } from "react";
import { Trans } from "react-i18next";
import { useGetActivitiesQuery, useGetPhonePrefixesQuery } from "../../../api";
import { fetchCreateApplication } from "../../../api/application.api";
import { Input } from "../../../components/simple/Input";
import { LbSelect } from "../../../components/simple/LbSelect";
import { history } from "../../../helpers/history";
import i18n from "../../../i18n";
import { BillingValidation } from "./validationSchema";
import { Column, Grid, Row } from "carbon-components-react";
import { Phone } from "../../../components/simple/Phone";
import LbCheckBox from "../../../components/simple/LbCheckBox";
import { LbLoader } from "../../../components/simple/LbLoader";

export const Index = () => {
  const { data: options, isError, error, isLoading } = useGetActivitiesQuery();
  const { data: phoneOptions, isLoading: isPhoneOptionsLoading } =
    useGetPhonePrefixesQuery();
  const formik = useFormik({
    initialValues: {
      productTypes: ["BILLING"],
      contactName: "",
      contactPhone: "",
      contactEmail: "",
      companyCode: "",
      companyName: "",
      activityCodes: null,
      phonePrefixes: {
        code: "+995",
        country: "Georgia",
        exampleNumber: i18n.t("Common.Phone.Placeholder"),
        format: "(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}",
        id: "GE",
        label: "+995",
        value: "GE",
      },
      agree: false,
    },
    validationSchema: BillingValidation,
    onSubmit: async (values, methods) => {
      const { setSubmitting, resetForm } = methods;
      try {
        setSubmitting(true);
        await fetchCreateApplication({
          ...values,
          activityCodes: {
            BILLING: values.activityCodes && values.activityCodes.value,
          },
        });
        resetForm();
        setSubmitting(false);
        history.push("/application/create/complete", {
          type: "success",
          productType: "BILLING",
        });
      } catch (error) {
        history.push("/application/create/complete", {
          type: "error",
          productType: "BILLING",
        });
      }
    },
  });

  const handleActivity = useCallback(
    async (val) => {
      await formik.setFieldValue("activityCodes", val);
      await formik.setFieldTouched("activityCodes", true);
    },
    [formik]
  );

  const handlePrefix = useCallback(
    async (val) => {
      await formik.setFieldValue("phonePrefixes", val);
    },
    [formik]
  );

  const handelAgree = useCallback(
    async (e) => {
      // e.preventDefault();
      await formik.setFieldValue("agree", !formik.values.agree);
    },
    [formik]
  );
  console.log(formik.errors);
  return (
    <Grid>
      <Row>
        <Column lg={12}>
          <div className="w-768">
            {/* ბილინგი */}
            <div className="text-center mb-64 mt-64">
              <h4 className="productive-heading-04 mb-24">
                <Trans i18nKey="Application.Billing.Title" />
              </h4>
              <p>
                <Trans i18nKey="Application.Billing.Description" />
              </p>
            </div>

            <div className="la-electronic-commerce">
              {/* <div className="la-electronic-commerce__row"> */}
              <Input
                label={i18n.t("Application.CashBack.contactName")}
                name="contactName"
                value={formik.values.contactName}
                onChange={formik.handleChange("contactName")}
                onBlur={formik.handleBlur("contactName")}
                error={
                  "contactName" in formik.errors &&
                  "contactName" in formik.touched
                }
              />

              <Phone
                phoneOptions={phoneOptions}
                isLoading={isLoading}
                label={i18n.t("Application.CashBack.contactPhone")}
                placeholder={
                  (formik.values.phonePrefixes &&
                    formik.values.phonePrefixes.exampleNumber) ||
                  i18n.t("Application.CashBack.contactPhone.Placeholder")
                }
                name="contactPhone"
                value={formik.values.contactPhone}
                prefixValue={formik.values.phonePrefixes}
                onChange={formik.handleChange("contactPhone")}
                onPrefixChange={handlePrefix}
                onBlur={formik.handleBlur("contactPhone")}
                error={
                  "contactPhone" in formik.errors &&
                  "contactPhone" in formik.touched
                }
              />
              {/* </div> */}
              {/* <div className="la-electronic-commerce__row"> */}
              <Input
                label={i18n.t("Application.CashBack.contactEmail")}
                name="contactEmail"
                value={formik.values.contactEmail}
                onChange={formik.handleChange("contactEmail")}
                onBlur={formik.handleBlur("contactEmail")}
                error={
                  "contactEmail" in formik.errors &&
                  "contactEmail" in formik.touched
                }
              />
              <Input
                label={i18n.t("Application.CashBack.companyName")}
                name="companyName"
                value={formik.values.companyName}
                onChange={formik.handleChange("companyName")}
                onBlur={formik.handleBlur("companyName")}
                error={
                  "companyName" in formik.errors &&
                  "companyName" in formik.touched
                }
              />
              {/* </div> */}
              {/* <div className="la-electronic-commerce__row"> */}
              <Input
                label={i18n.t("Application.CashBack.companyCode")}
                name="companyCode"
                value={formik.values.companyCode}
                onChange={formik.handleChange("companyCode")}
                onBlur={formik.handleBlur("companyCode")}
                error={
                  "companyCode" in formik.errors &&
                  "companyCode" in formik.touched
                }
                placeholder={i18n.t(
                  "Application.CashBack.companyCode.Placeholder"
                )}
              />
              <LbSelect
                options={
                  options && options.filter((i) => i.productType === "BILLING")
                }
                isLoading={isLoading}
                label={i18n.t("Application.Pos.activityCode")}
                value={formik.values.activityCodes}
                onChange={handleActivity}
                onBlur={formik.handleBlur("activityCode")}
                placeholder={i18n.t("Application.Pos.activityCode")}
              />

              {/* </div> */}

              <div className="agreement-terms mb-32">
                <p className="agreement-terms__details code-02">
                  {i18n.t("Application.ECommerce.AgreeRules")}
                </p>
                <LbCheckBox
                  id="agree"
                  i18nKey="Application.CashBack.AcceptRules"
                  name="agree"
                  value={formik.values.agree}
                  checked={!!formik.values.agree}
                  onLabelClick={handelAgree}
                  onChange={handelAgree}
                  onBlur={formik.handleBlur("agree")}
                  error={"agree" in formik.errors && "agree" in formik.touched}
                />
              </div>

              <button
                className={`btn btn-black btn-request `}
                type="button"
                disabled={
                  !formik.dirty || formik.isSubmitting || !formik.isValid
                }
                onClick={formik.submitForm}
              >
                {formik.isSubmitting ? (
                  <LbLoader isLoading />
                ) : (
                  <Trans i18nKey="Common.Create" />
                )}
              </button>
            </div>
          </div>
        </Column>
      </Row>
    </Grid>
  );
};
